import { POST_KEY } from '../../index'
import { MEDIA_LAYOUT_TYPE, MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX } from '../../../../../modules/images/constants'
import { getIdReduxUtil } from '../../../../../modules/redux/utils/get-id'
import { getValueReduxUtil } from '../../../../../modules/redux/utils/get-value'

function getImageUriPostUtil (post, layoutType) {
  if (!post) {
    return
  }
  const image = getValueReduxUtil(post, POST_KEY.IMAGE)
  if (!image) {
    return
  }
  const id = getIdReduxUtil(post)
  const imageSuffix = (
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[layoutType] ||
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[MEDIA_LAYOUT_TYPE.SMALL]
  )
  return `posts/${id}/${image.replace('.', `-${imageSuffix}.`)}`
}

export {
  getImageUriPostUtil
}
